import React from 'react';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Friends from './Friends/Friends';

import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import AppointmentHistory from './AppointmentHistory/AppointmentHistory';

class RelationManagement extends React.Component{

    componentDidMount() {
        if (this.props.isAuthenticated === true) {
            this.props.getRelations();
        }
        else {
            setTimeout(
                () => {
                    this.props.getRelations();
                },
                100
            )
        }
        window.scrollTo(0, 0);
    }

    render(){

        return (
            <div>
            <Helmet>
            <title>Assist | BookMeeY</title>
            <meta name="description" content="Assist you for email confirmation, password reset, and many more." />
            </Helmet>
            <Route path="/relation/friends" component={Friends}/>
            <Route path="/relation/appointments" component={AppointmentHistory}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getRelations: () => dispatch( actions.relationGet() ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (RelationManagement);


// WEBPACK FOOTER //
// ./src/containers/RelationManagement/RelationManagement.js